import script from "./GeneticReportsNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneticReportsNotice.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__